import { baseApi } from '../baseApi';
import type { ListParams } from '../api';

export interface Notification {
  id: string;
  title: string;
  body: string;
  type: string;
  target: 'all' | 'selected';
  targetStudentIds?: string[];
  classId: string;
  createdAt: string;
  students?: {
    id: string;
    name: string;
    email: string;
    mobile: string;
    status: string;
  }[];
}

export interface ListResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
}

export const notificationApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    getAdminNotifications: b.query<ListResponse<Notification>, ListParams>({
      query: (params = {}) => ({ url: "/api/notifications", params }),
      providesTags: ["Dashboard"] as any, // or create "Notification" tag later
    }),
    getAdminNotificationById: b.query<{ success: boolean; data: Notification }, string>({
      query: (id) => ({ url: `/api/notifications/${id}` }),
      providesTags: (result, error, id) => [{ type: "Dashboard" as any, id }],
    }),
  }),
});

export const {
  useGetAdminNotificationsQuery,
  useGetAdminNotificationByIdQuery,
} = notificationApi;
